import { ac } from '../actions'

export const SHOW_FLOATING_AUTH_PANEL = 'SHOW_FLOATING_AUTH_PANEL'
export const HIDE_FLOATING_AUTH_PANEL = 'HIDE_FLOATING_AUTH_PANEL'

export const showFloatingAuthPaenl = () => ac(SHOW_FLOATING_AUTH_PANEL)

export const hideFloatingAuthPanel = () => ac(HIDE_FLOATING_AUTH_PANEL)
